import type { AxiosResponse } from 'axios'

import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const ENDPOINT = '/v1.0/rental' as const

interface RentalListParameters {
  searchQuery?: string
  pageNumber?: number
  pageSize?: number
  sortBy?: string
  orderBy?: string
}

interface RequestRentalBody {
  materialNumber: string
}

interface RentalService {
  getList: (parameters: RentalListParameters) => Promise<AxiosResponse>
  getIsRentable: (materialNumber: string) => Promise<AxiosResponse>
  requestRental: (body: RequestRentalBody) => Promise<AxiosResponse>
}

const fapiClient = new HttpClient(environment.shopFAPIUrl)

export const rentalService: RentalService = {
  async getList({
    searchQuery,
    pageNumber,
    pageSize = 10,
    sortBy,
    orderBy,
  }: RentalListParameters): Promise<AxiosResponse> {
    return fapiClient.get(`${ENDPOINT}/search`, {
      params: {
        searchQuery,
        pageNumber,
        pageSize,
        sortBy,
        orderBy,
      },
    })
  },

  async getIsRentable(materialNumber: string): Promise<AxiosResponse> {
    return fapiClient.get(`${ENDPOINT}/isrentable/${materialNumber}`)
  },

  async requestRental(body: RequestRentalBody): Promise<AxiosResponse> {
    return fapiClient.post(`${ENDPOINT}/create`, { body })
  },
}

export type { RentalListParameters as RentalListParams, RentalService }
